import { render, staticRenderFns } from "./SuggestedBanner.vue?vue&type=template&id=03bcbefc"
import script from "./SuggestedBanner.vue?vue&type=script&lang=js"
export * from "./SuggestedBanner.vue?vue&type=script&lang=js"
import style0 from "./SuggestedBanner.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports